var map = {
	"./facebook.png": 39887,
	"./instagram.png": 99388,
	"./linkedin.png": 50086,
	"./tiktok.png": 14168,
	"./twitter.png": 20574,
	"./x-logo.png": 94502,
	"./x.png": 34238
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17757;